import * as React from 'react';
import * as style from './style.scss';
import { Fallback } from 'components/common';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { formatNumber, handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { Button } from 'react-bootstrap';

export interface ICashTransferConfirmFormProps
  extends React.ClassAttributes<CashTransferConfirmFormComponent>,
    WithNamespaces {
  readonly titleHeader: string;
  readonly localBank?: any;
  readonly isBankTransfer?: boolean;
  readonly transferAmount?: number;
  readonly advanceAmount?: number;
  readonly content?: string;
  readonly fee?: number;
  readonly selectedAccount?: any;
  readonly beneficiaryAccountNo?: string;
  readonly onChangeStep: (step: number) => void;
}

export interface ICashTransferConfirmFormState {
}
class CashTransferConfirmFormComponent extends React.Component<
  ICashTransferConfirmFormProps,
  ICashTransferConfirmFormState
> {
  constructor(props: ICashTransferConfirmFormProps) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <div className={style.CashTransferConfirmForm}>
        {this.props.isBankTransfer ? (
          <div className={style.ConfirmBankTransfer}>
            <div className={style.Title}>
              <p>{t(this.props.titleHeader)}</p>
            </div>
            <div>
              <p>{t("Beneficiary's name")}</p>
              <p className={style.TextBox}>{this.props.localBank?.ownerName ?? this.props.selectedAccount?.accountName}</p>
            </div>
            <div>
              <p>{t("Beneficiary's account number")}</p>
              <p className={style.TextBox}>{this.props.localBank?.bankId}</p>
            </div>
            <div>
              <p>{t("Beneficiary's Bank")}</p>
              <p className={style.TextBox}>{this.props.localBank?.bankName}</p>
            </div>

            <div>
              <p>{t('Transfer Amount1')}</p>
              <p className={style.TextBox}>
                {formatNumber(this.props.transferAmount)} VNĐ
              </p>
            </div>
            <div style={{ gap: 1 }}>
              <p>{t('Advance Amount')}</p>
              <div className={style.BenificiaryAdvanceAmt}>
                <p style={{ width: '100%' }} className={style.TextBox}>
                  {formatNumber(this.props.advanceAmount) +
                    ` VNĐ (${t('Advance Fee')}: ${formatNumber(this.props.fee)} VNĐ)`}
                </p>
                {(this.props.fee ?? 0) > 0 && (
                  <p
                    style={{
                      marginBottom: 10,
                      fontWeight: 400,
                      color: 'red',
                    }}
                  >
                    {t('Advance Amount Note')}
                  </p>
                )}
              </div>
            </div>
            <div>
              <p>{t('Content')}</p>
              <p className={style.TextBox}>{this.props.content}</p>
            </div>
            <div className={style.GroupBtnControl}>
              <Button
                className={style.BtnCancel}
                onClick={() => this.props.onChangeStep(0)}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={style.BtnNext}
                onClick={() => this.props.onChangeStep(2)}
              >
                {t('Next')}
              </Button>
            </div>
          </div>
        ) : (
          <div className={style.ConfirmInternalCashTransfer}>
            <div className={style.Title}>
              <p>{t('Confirm internal cash transfer information')}</p>
            </div>
            <div>
              <p>{t('Source Account')}</p>
              <p className={style.TextBox}>
                {this.props.selectedAccount?.account}
              </p>
            </div>
            <div>
              <p>{t("Beneficiary's Account")}</p>
              <p className={style.TextBox}>{this.props.beneficiaryAccountNo}</p>
            </div>
            <div>
              <p>{t('Transfer Amount1')}</p>
              <p className={style.TextBox}>
                {formatNumber(this.props.transferAmount) + ' VNĐ'}
              </p>
            </div>
            <div style={{ gap: 1 }}>
              <p>{t('Advance Amount')}</p>
              <div className={style.BenificiaryAdvanceAmt}>
                <p style={{ width: '100%' }} className={style.TextBox}>
                  {formatNumber(this.props.advanceAmount) +
                    ` VNĐ (${t('Advance Fee')}: ${formatNumber(this.props.fee)} VNĐ)`}
                </p>
                {(this.props.fee ?? 0) > 0 && (
                  <p style={{ marginBottom: 10, fontWeight: 400, color: 'red', }}>{t('Advance Amount Note')}</p>
                )}
              </div>
            </div>
            <div>
              <p>{t('Content')}</p>
              <p className={style.TextBox}>{this.props.content}</p>
            </div>
            <div className={style.GroupBtnControl}>
              <Button
                className={style.BtnCancel}
                onClick={() => this.props.onChangeStep(0)}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={style.BtnNext}
                onClick={() => this.props.onChangeStep(2)}
              >
                {t('Next')}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const CashTransferConfirmForm = withErrorBoundary(
  withNamespaces('common')(CashTransferConfirmFormComponent),
  Fallback,
  handleError
);

export default CashTransferConfirmForm;



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/Common/CashTransferConfirmForm/index.tsx